import React from 'react'
import styles from './OfferFourthPage.module.scss'
import CaddieDisplay from '../../../components/CaddieDisplay/CaddieDisplay'
import ProDisplay from '../../../components/ProDisplay/ProDisplay'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { useStateMachine } from 'little-state-machine'
import { useCreateOffer, useCreatePreContract } from '../../../hooks/offer'
import { useToken } from '../../../utils/auth'

const OfferFourthPage = () => {
	const { state } = useStateMachine()
	const [searchParams] = useSearchParams()

	// URL 파라미터에서 사용자 타입 확인
	const userType = searchParams.get('by') || 'pro'
	const isCaddieView = userType === 'caddie'

	const [text, setText] = useState('')
	const [textAmount, setTextAmount] = useState(0)
	const navigate = useNavigate()
	const [isSuccessMessageOpen, setIsSuccessMessageOpen] = useState(false)
	const { mutate: createOfferMutation, isLoading } = useCreateOffer()
	const { mutate: createPreContractMutation, isLoading: isPreContractLoading } =
		useCreatePreContract()
	const token = useToken()

	// Store에서 데이터 가져오기
	const offerData = state.offerInput
	const selectedUser = isCaddieView ? offerData?.selectedPro : offerData?.selectedCaddie

	// 사전계약인지 확인
	const isPreContract = offerData?.offerType === 'preContract'
	const isLoadingAny = isLoading || isPreContractLoading

	const onSubmit = async () => {
		const resolvedTargetUserId =
			offerData?.targetUserId ||
			(isCaddieView ? offerData?.selectedPro?.id : offerData?.selectedCaddie?.id)
		if (!offerData || !resolvedTargetUserId) {
			alert('필수 정보가 없습니다.')
			return
		}

		// 사전계약인지 확인
		const isPreContract = offerData.offerType === 'preContract'

		if (isPreContract) {
			// 사전계약용 데이터 (메시지와 타겟 유저 ID만 필요)
			const preContractData = {
				message: text,
				targetUserId: resolvedTargetUserId,
			}

			console.log('preContractData:', preContractData)

			// 사전계약 API 사용
			createPreContractMutation(
				{
					token,
					preContractData: preContractData,
				},
				{
					onSuccess: (data) => {
						console.log('사전계약 제안 성공:', data)
						setIsSuccessMessageOpen(true)
						setTimeout(() => {
							setIsSuccessMessageOpen(false)
							navigate('/precontracts', { state: { defaultTab: 'sent' } })
						}, 2000)
					},
					onError: (error) => {
						console.error('사전계약 제안 실패:', error)
						alert('사전계약 제안에 실패했습니다.')
					},
				},
			)
		} else {
			// 일반 제안용 데이터
			const offerPayload = {
				...offerData,
				targetUserId: resolvedTargetUserId,
				message: text,
			}

			console.log('offerPayload:', offerPayload)

			// 일반 제안 API 사용
			createOfferMutation(
				{
					token,
					offerData: offerPayload,
				},
				{
					onSuccess: (data) => {
						console.log('제안 성공:', data)
						setIsSuccessMessageOpen(true)
						setTimeout(() => {
							setIsSuccessMessageOpen(false)
							navigate('/offers', { state: { defaultTab: 'sent' } })
						}, 2000)
					},
					onError: (error) => {
						console.error('제안 실패:', error)
						alert('제안에 실패했습니다.')
					},
				},
			)
		}
	}

	return (
		<div className={styles.suggestDefaultPageContainer}>
			{isSuccessMessageOpen && (
				<div className={styles.successMessage}>
					<CheckCircleIcon className={styles.checkFinishIcon} />
					제안하기가 완료되었어요!
				</div>
			)}
			<div className={styles.title}>제안하기</div>
			{isCaddieView ? (
				<ProDisplay pro={selectedUser} alreadyOffer={true} />
			) : (
				<CaddieDisplay caddie={selectedUser} alreadyOfferPage={true} />
			)}
			<div className={styles.progressBar}></div>
			<div className={styles.detailTitle}>간략 제안 메세지를 입력해주세요</div>
			<div className={styles.textWrapper}>
				<div className={styles.textTitle}>메세지</div>
				<textarea
					className={styles.textArea}
					placeholder={
						isCaddieView
							? '예: 김프로님 김캐디입니다. 프로필을 보고 프로 제안드립니다. (500자 이내)'
							: '예: 김캐디님 김프로입니다. 프로필을 보고 캐디 제안드립니다. (500자 이내)'
					}
					value={text}
					maxLength={500}
					onChange={(e) => {
						setText(e.target.value)
						setTextAmount(e.target.value.length)
					}}
				/>
				<div className={styles.textAmountContainer}>
					<div className={styles.textAmount}>{textAmount} / 500</div>
				</div>
			</div>
			<div className={styles.buttonContainer}>
				<button
					className={styles.goBackButton}
					onClick={() => navigate(-1)}
					disabled={isLoadingAny}>
					이전
				</button>
				<button
					className={`${styles.nextButton}`}
					onClick={onSubmit}
					disabled={isLoadingAny || isSuccessMessageOpen}>
					{isLoadingAny
						? isPreContract
							? '사전계약 제안 중...'
							: '제안 중...'
						: isSuccessMessageOpen
							? '제안 완료!'
							: '제안하기'}
				</button>
			</div>
		</div>
	)
}

export default OfferFourthPage
